class RecipeNavigationController {
    constructor(recipeCategoriesService, analyticsService) {
        this.recipeCategoriesService = recipeCategoriesService;
        this.analyticsService = analyticsService;
    }

    $onInit() {
        this.recipeCategoriesService.getAll();
    }

    $onChanges() {
        if (this.currentCategory) {
            this.openCategory = this.currentCategory.department;
        }
    }

    toggleOpen(category) {
        this.openCategory = this.openCategory === category
            ? null
            : category;
    }

    pushDataToAnalyticsService() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.menuClick,
        });
    }
}

const recipeNavigationComponentDefinition = {
    bindings: {
        currentCategory: '<',
    },
    controller: ['RecipeCategoriesService', 'AnalyticsService', RecipeNavigationController],
    template: require('./recipe-navigation.component.html').trim(),
};

module.exports = {
    RecipeNavigationController,
    recipeNavigationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipe-navigation.component.js